module.exports = __webpack_public_path__ + "static/media/penciledit.67966463.svg";